import { ref } from "vue";

/**
 * @function 項目選択用のダイアログ
 */

export default function useSelectDialog() {
  const selectDialogVisible = ref(false);

  const handleCloseDialog = () => {
    selectDialogVisible.value = false;
  };
  const handleSelect = () => {
    selectDialogVisible.value = true;
  };
  return {
    selectDialogVisible,
    handleCloseDialog,
    handleSelect,
  };
}
